import { createSelector } from 'reselect'
import { removeTrailingSlash } from '@offerzen/pinata-shame'
import browserHistory from '../../config/browserHistory'

const getHistory = state => state.sessionHistory.history
const getCurrentParent = state => state.sessionHistory.currentParent

export const getPreviousLocation = createSelector([getHistory], history => (history.length > 1 ? history[history.length - 2] : null))
export const getPreviousHref = createSelector([getPreviousLocation], previous => (previous ? browserHistory.createHref(previous) : null))

export const getPreviousTopLevelLocation = createSelector(
  [getCurrentParent, getPreviousLocation],
  (topLevel, previous) => topLevel || previous,
)

export const getPreviousTopLevelHref = createSelector([getHistory, getPreviousTopLevelLocation], (history, previous) => {
  if (history.length <= 1) return previous ? browserHistory.createHref(previous) : null

  const cleanTopLevel = previous ? removeTrailingSlash(previous.pathname) : ''
  const parent = history
    .slice(0, -1)
    .reverse()
    .find(location => removeTrailingSlash(location.pathname) === cleanTopLevel)

  if (!parent) return previous ? browserHistory.createHref(previous) : null
  return browserHistory.createHref(parent)
})
